/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SelectOptionCommand } from '../../models/select-option-command';
import { SelectOptionCommandResult } from '../../models/select-option-command-result';

export interface ApiKpiReportsSelectOptionPost$Params {
      body?: SelectOptionCommand
}

export function apiKpiReportsSelectOptionPost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsSelectOptionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SelectOptionCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsSelectOptionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SelectOptionCommandResult>;
    })
  );
}

apiKpiReportsSelectOptionPost.PATH = '/api/KPIReports/SelectOption';
